angular.module("dx.webapp.navigation", []);
